import { FC } from 'react'
import cn from 'classnames'
import Select, { components, ContainerProps } from 'react-select'
import { SelectComponentsProps } from 'react-select/src/Select'

// Assets
import { ReactComponent as IconApprove } from 'images/icons/icon-transparent-approve.svg'
import styles from './Filter.module.scss'

export const filterColors = {
  purpleGray: 'var(--violet-500)',
  lightPurple: 'var(--violet-150)',
  darkPurple: 'var(--violet-600)',
  darkGray: 'var(--grey-800)',
  lightGray: 'var(--grey-350)',
  white: 'var(--light-100)',
}

export const filterStyles = {
  control: (base: any) => ({
    ...base,
    height: 45,
    maxHeight: 45,
    border: 0,
    boxShadow: 'none',
    cursor: 'pointer',
    '&:hover': {
      border: 0,
    },
  }),
  valueContainer: (base: any) => ({
    ...base,
    height: 45,
    maxHeight: 45,
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    display: 'none',
  }),
  clearIndicator: (base: any) => ({
    ...base,
    background: filterColors.purpleGray,
    color: filterColors.white,
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    cursor: 'pointer',
    svg: {
      transform: 'scale(0.7)',
    },
    '&:hover': {
      color: filterColors.white,
    },
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    color: filterColors.purpleGray,
    cursor: 'pointer',
    '&:hover': {
      color: filterColors.purpleGray,
    },
  }),
  menu: (base: any) => ({
    ...base,
    boxShadow: 'none',
    borderRadius: '6px',
    marginTop: 'var(--space-md)',
    zIndex: 3,
  }),
  menuList: (base: any) => ({
    ...base,
    padding: 0,
    boxShadow: '0px 4px 16px rgba(187, 196, 239, 0.35)',
    borderRadius: '6px',
  }),
  option: (base: any) => ({
    ...base,
    background: filterColors.white,
    color: filterColors.darkPurple,
    minHeight: 48,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',

    '&:hover': {
      background: filterColors.lightPurple,
    },

    '&:focus': {
      background: filterColors.lightPurple,
    },
  }),
  placeholder: (base: any) => ({
    ...base,
    color: filterColors.lightGray,
  }),
  Svg: (base: any) => ({
    ...base,
    width: 15,
    fill: filterColors.purpleGray,
  }),
}

export const CustomOption: FC<SelectComponentsProps> = ({ selectProps, label, isSelected, ...props }: any) => {
  const { dataTestId } = selectProps

  return (
    <components.Option
      {...props}
      className={cn(props.className, isSelected && styles.optionSelected)}
      innerProps={Object.assign({}, props.innerProps, {
        'data-test-id': `${dataTestId}_option`,
      })}
    >
      <div className={styles.optionContainer}>
        {label}
        {isSelected && <IconApprove strokeWidth="3" width={25} height={25} className={styles.optionSelectedIcon} />}
      </div>
    </components.Option>
  )
}

export const CustomContainer: FC<ContainerProps<any, any>> = ({ selectProps, ...commonProps }: any) => {
  const { dataTestId } = selectProps
  return (
    <components.SelectContainer
      {...commonProps}
      innerProps={{
        ...commonProps.innerProps,
        'data-test-id': `${dataTestId}_container`,
      }}
    />
  )
}

const Filter = ({ className = '', ...props }) => (
  <Select
    {...props}
    className={cn(className, styles.filter)}
    styles={filterStyles}
    components={{ Option: CustomOption, SelectContainer: CustomContainer }}
  />
)

export default Filter
